import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import SideBarComponent from "./components/navbar/SideBarComponent";
import TopBarComponent from "./components/navbar/TopBarComponent";
import { Suspense, lazy } from "react";
//dashboard component
const DashBoardComponent = lazy(() => import("./components/dashboard/DashBoardComponent"));
//unit dashboard component
const UnitDashBoardComponent = lazy(()=>import("./components/dashboard/UnitDashBoard"));
//company dashboard component
const CompanyDashBoardComponent = lazy(()=>import("./components/dashboard/CompanyDashBoard"))
//company to unit dashboard component
const CompanyToUnitDashboardComponent = lazy(()=>import("./components/dashboard/Company_To_UnitDashboard"))
//super admin dashboard
const SuperAdminDashboardComponent = lazy(()=>import("./components/dashboard/SuperAdminDashboard"))
//login component
const LoginComponent = lazy(() => import("./components/login/Login"));
//forgot component
const EmailValidationComponent = lazy(()=>import("./components/forgotPassword/EmailValidation"))
const OTPVerificationComponent = lazy(()=>import("./components/forgotPassword/OtpVerification"))
const ForgotPasswordComponent = lazy(()=>import("./components/forgotPassword/ForgotPassword"))
//user component
const ManageUserComponent = lazy(()=>import("./components/manageUser/ManageUser"));
const AddUserComponent = lazy(()=>import("./components/manageUser/AddNewUser"));
const UpdateUserComponent = lazy(()=>import("./components/manageUser/UpdateUser"));
const GenerateUserQRComponent = lazy(()=>import("./components/manageUser/GenerateUserQR"));
//company component
const ManageCompanyComponent = lazy(()=>import("./components/manageCompany/ManageCompany"));
const AddCompanyComponent = lazy(()=>import("./components/manageCompany/AddNewCompany"));
const UpdateCompanyComponent = lazy(()=>import("./components/manageCompany/UpdateCompany"));
//department component
const ManageDepartmentComponent = lazy(()=>import("./components/manageDepartment/ManageDepartment"));
const AddDepartmentComponent = lazy(()=>import("./components/manageDepartment/AddNewDept"));
const UpdateDepartmentComponent = lazy(()=>import("./components/manageDepartment/UpdateDept"));
//machine component
const ManageMachineComponent = lazy(()=>import("./components/manageMachine/ManageMachine"));
const AddMachineComponent = lazy(()=>import("./components/manageMachine/AddNewMachine"));
const UpdateMachineComponent = lazy(()=>import("./components/manageMachine/UpdateMachine"));
const GenerateMachineQRComponent = lazy(()=>import("./components/manageMachine/GenerateMachineQR"));
//work component
const ManageWorkComponent = lazy(()=>import("./components/manageWorkOrder/ManageWork"));
const AddWorkComponent = lazy(()=>import("./components/manageWorkOrder/AddNewWork"));
const UpdateWorkComponent = lazy(()=>import("./components/manageWorkOrder/UpdateWork"));
const GenerateWorkQRComponent = lazy(()=>import("./components/manageWorkOrder/GenerateWorkQR"));
//workTrack Component
const ManageWorkTrackComponent = lazy(()=>import("./components/manageWorkTrack/ManageWorkTrack"));
const AddWorkTrackComponent = lazy(()=>import("./components/manageWorkTrack/AddNewWorkTrack"));
const UpdateWorkTrackComponent = lazy(()=>import("./components/manageWorkTrack/UpdateWorkTrack"));
//client component
const ManageClientComponent = lazy(()=>import("./components/manageClient/ManageClient"));
const AddClientComponent = lazy(()=>import("./components/manageClient/AddClient"));
const UpdateClientComponent = lazy(()=>import("./components/manageClient/UpdateClient"));
//punch inout component
const ManagePunchInOutComponent = lazy(()=>import("./components/managePunchInOut/ManagePunchInOut"));
//report component
const ManageReportComponent = lazy(()=>import("./components/manageReport/ManageReport"))
//qr component
const ManageQRComponent = lazy(()=>import("./components/manageQR/PrintQR"))
function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === "/" || location.pathname === "/Email-Validation" || location.pathname === "/Otp-Verification" || location.pathname === "/Forgot-Password";

  return (
    <>
      <div className="app">
        {!isLoginPage && <SideBarComponent />}
        <main className="content">
          {!isLoginPage && <TopBarComponent />}
          <Routes>
            <Route path="/">
              <Route index element={<Suspense fallback={<div>Loading..</div>}><LoginComponent /></Suspense>} />
              <Route path="Email-Validation" element={<Suspense fallback={<div>Loading..</div>}><EmailValidationComponent /></Suspense>} />
              <Route path="Otp-Verification" element={<Suspense fallback={<div>Loading..</div>}><OTPVerificationComponent /></Suspense>} />
              <Route path="Forgot-Password" element={<Suspense fallback={<div>Loading..</div>}><ForgotPasswordComponent /></Suspense>} />

              </Route>
              <Route path="/magod">
                <Route index element={<Suspense fallback={<div>Loading..</div>}><DashBoardComponent /></Suspense>} />
                <Route path="DashBoard" element={<Suspense fallback={<div>Loading..</div>}><DashBoardComponent /></Suspense>} />
                <Route path="UnitDashBoard" element={<Suspense fallback={<div>Loading..</div>}><UnitDashBoardComponent/></Suspense>}/>
                <Route path="CompanyDashboard" element={<Suspense fallback={<div>Loading..</div>}><CompanyDashBoardComponent/></Suspense>}/>
                <Route path="Company_to_UnitDashboard/:uid" element={<Suspense fallback={<div>Loading..</div>}><CompanyToUnitDashboardComponent/></Suspense>}/>
                <Route path="SuperAdminDashboard" element={<Suspense fallback={<div>Loading..</div>}><SuperAdminDashboardComponent/></Suspense>}/>

                <Route path="manageUser" element={<Suspense fallback={<div>Loading..</div>}><ManageUserComponent/></Suspense>}/>
                <Route path="addUser" element={<Suspense fallback={<div>Loading..</div>}><AddUserComponent/></Suspense>}/>
                <Route path="updateUser/:uid" element={<Suspense fallback={<div>Loading..</div>}><UpdateUserComponent/></Suspense>}/>
                <Route path="addQRCode/:qid" element={<Suspense fallback={<div>Loading..</div>}><GenerateUserQRComponent/></Suspense>}/>

                <Route path="manageCompany" element={<Suspense fallback={<div>Loading..</div>}><ManageCompanyComponent/></Suspense>}/>
                <Route path="addCompany" element={<Suspense fallback={<div>Loading..</div>}><AddCompanyComponent/></Suspense>}/>
                <Route path="updateCompany/:cid" element={<Suspense fallback={<div>Loading..</div>}><UpdateCompanyComponent/></Suspense>}/>

                <Route path="manageDepartment" element={<Suspense fallback={<div>Loading..</div>}><ManageDepartmentComponent/></Suspense>}/>
                <Route path="addDepartment" element={<Suspense fallback={<div>Loading..</div>}><AddDepartmentComponent/></Suspense>}/>
                <Route path="updateDepartment/:did" element={<Suspense fallback={<div>Loading..</div>}><UpdateDepartmentComponent/></Suspense>}/>

                <Route path="manageMachine" element={<Suspense fallback={<div>Loading..</div>}><ManageMachineComponent/></Suspense>}/>
                <Route path="addMachine" element={<Suspense fallback={<div>Loading..</div>}><AddMachineComponent/></Suspense>}/>
                <Route path="updateMachine/:mid" element={<Suspense fallback={<div>Loading..</div>}><UpdateMachineComponent/></Suspense>}/>
                <Route path="addMachineQR/:mqid" element={<Suspense fallback={<div>Loading..</div>}><GenerateMachineQRComponent/></Suspense>}/>

                <Route path="manageWork" element={<Suspense fallback={<div>Loading..</div>}><ManageWorkComponent/></Suspense>}/>
                <Route path="addWork" element={<Suspense fallback={<div>Loading..</div>}><AddWorkComponent/></Suspense>}/>
                <Route path="updateWork/:wid" element={<Suspense fallback={<div>Loading..</div>}><UpdateWorkComponent/></Suspense>}/>
                <Route path="addWorkQR/:wqid" element={<Suspense fallback={<div>Loading..</div>}><GenerateWorkQRComponent/></Suspense>}/>

                <Route path="manageWorkTrack" element={<Suspense fallback={<div>Loading..</div>}><ManageWorkTrackComponent/></Suspense>}/>
                <Route path="addWorktrack" element={<Suspense fallback={<div>Loading..</div>}><AddWorkTrackComponent/></Suspense>}/>
                <Route path="updateWorktrack" element={<Suspense fallback={<div>Loading..</div>}><UpdateWorkTrackComponent/></Suspense>}/>

                <Route path="manageClient" element={<Suspense fallback={<div>Loading..</div>}><ManageClientComponent/></Suspense>}/>
                <Route path="addClient" element={<Suspense fallback={<div>Loading..</div>}><AddClientComponent/></Suspense>}/>
                <Route path="updateClient/:cid" element={<Suspense fallback={<div>Loading..</div>}><UpdateClientComponent/></Suspense>}/>

                <Route path="managePunchInOut" element={<Suspense fallback={<div>Loading..</div>}><ManagePunchInOutComponent/></Suspense>}/>
                
                <Route path="manageReport" element={<Suspense fallback={<div>Loading..</div>}><ManageReportComponent/></Suspense>}/>

                <Route path="managePrintQR" element={<Suspense fallback={<div>Loading..</div>}><ManageQRComponent/></Suspense>}/>
            </Route>
            <Route path="*" element={<div>Page Not Found..</div>} />
          </Routes>
        </main>
      </div>
    </>
  );
}

export default App;
